import { PriceIntersectsFirstCandleModule } from '../../../../components/displays/alerts/components/addAlertComponent/addAlertForm/formComponents/setupFilters/setupFiltersModules/priceIntersectsFirstCandle/PriceIntersectsFirstCandleModule';
import { PriceIntersectsFirstCandleLine } from '../../../../components/displays/charts/d3/candlestickchart/newCandleChart/softOrders/softOrderChartComponents/setupFilters/PriceIntersectsFirstCandleLine';
import { PriceIntersectsFirstCandleTacticPanel } from '../../../../components/displays/tradeplans/activeTradePlanModule/components/detailsSection/individualTacticPanels/setupFilters/PriceIntersectsFirstCandleTacticPanel';
import { PriceIntersectsFirstCandleWrapper } from '../../../../components/displays/tradeplans/softOrderModules/SetupFilterModules/PriceIntersectsFirstCandleModule/wrapper/PriceIntersectsFirstCandleWrapper';
import PriceIntersectsFirstCandleDocs from '../../../../components/forms/tradeplans/documentation/PriceIntersectsFirstCandleDocumentation';
import { priceIntersectsFirstCandleFilterParser } from '../../../../stores/websocketStore/utils/mungingUtils/alertSoftOrderProcessing/individualFilterStatusParsers/priceIntersectsFirstCandle/priceIntersectsFirstCandleFilterParser';
import { PriceIntersectsFirstCandleData } from './priceIntersectsFirstCandleData';
import { validatePriceIntersectsFirstCandle } from './validatePriceIntersectsFirstCandle';


export const PriceIntersectsFirstCandle = {
  //data class
  dataStore: PriceIntersectsFirstCandleData,

  //string constants
  name: 'PRICE_INTERSECTS_FIRST_CANDLE',
  tacticLabel: 'Price Intersects First Candle',
  addTacticLabel: 'Add Price Intersects First Candle',
  category: 'Setup Filter',


  // components
  tradePlanFormModule: null,
  tacticPanel: PriceIntersectsFirstCandleTacticPanel,
  addTacticPanel: null,
  wrapper: PriceIntersectsFirstCandleWrapper,
  chartSoftOrderComponent: PriceIntersectsFirstCandleLine,
  documentation: PriceIntersectsFirstCandleDocs,
  alertDetailsComponent: PriceIntersectsFirstCandleModule,

  //functions
  setupDetailParser: null, //todo
  filterStatusParser: priceIntersectsFirstCandleFilterParser,
  validationFunction: validatePriceIntersectsFirstCandle,
};
